@for (cartContainer of compData?.containers; track cartContainer) {
  <div>
    <div class="pty-rvw-wrap">
      <!-- Registration promotion -->
      @if (cartContainer?.promotionData?.registrationCard?.showRegistrationCard) {
        <div class="login-card">
          <div class="register-wrap">
            <div class="log-img">
              <div class="img">
                <img [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/login.webp'"
                     width="100"
                     height="100" loading="lazy"
                     alt="login">
              </div>
            </div>
            <div class="title">{{ cartContainer?.promotionData?.registrationCard?.title }}</div>
            <div class="btn-wrap">
              <div class="login-btn">
                <button (click)="openLoginPopup()" tapEffect>Login</button>
              </div>
            </div>
          </div>
        </div>
      }
      <!-- Membership promotion -->
      @if (cartContainer?.promotionData?.membershipCard?.showMembershipCard) {
        <div class="mem-card">
          <div class="header">
            <div class="mem-header">
              @if (cartContainer?.promotionData?.membershipCard?.displayName) {
                <div class="title">
                  {{ cartContainer?.promotionData?.membershipCard?.displayName }}
                  <!--BAG2BAG TRUE BELIEVER-->
                </div>
              }
              <!--<div class="title" *ngIf="cartContainer?.promotionData?.membershipCard?.description">
              {{ cartContainer?.promotionData?.membershipCard?.description }}
            </div>-->
              <div class="benefit-title">
                @if (cartContainer?.promotionData?.membershipCard?.description) {
                  <a
                    [href]="cartContainer?.promotionData?.membershipCard?.navigationURL"
                    target="_blank" class="benefit-btn"
                  >{{ cartContainer?.promotionData?.membershipCard?.description }}</a>
                }
              </div>
            </div>
          </div>
          <div class="mem-bdy">
            @for (text of cartContainer?.promotionData?.membershipCard?.textList; track text) {
              <div class="title-wrap">
                <div>
                  <img [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/tick-orange.webp'"
                       alt="tick"
                       width="100" height="100"
                       loading="lazy"
                  >
                </div>
                <span class="title">{{ text }}</span>
              </div>
            }
          </div>
          <div class="mem-footer">
            <div class="title">Membership at ₹1499/- only</div>
            @if (!membershipBody?.isAdd) {
              <div tapEffect
                   (click)="toggleMembership(true, cartContainer?.promotionData?.membershipCard)">
                <button class="add-btn">
                  + Add
                  <!--<span *ngIf="cartContainer?.promotionData?.membershipCard?.subTitle">
                {{cartContainer?.promotionData?.membershipCard?.subTitle}}</span>-->
                </button>
              </div>
            }
            @if (membershipBody?.isAdd) {
              <div tapEffect
                   (click)="toggleMembership(false, cartContainer?.promotionData?.membershipCard)"
                   class="flex-container ion-justify-content-end">
                <button class="rm-btn">
                  Remove
                  <span>
                    <svg class="close-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 30">
                      <line x1="15" y1="15" x2="25" y2="25" stroke="#cb0000" stroke-width="2.5" stroke-linecap="round"
                            stroke-miterlimit="10"></line>
                      <line x1="25" y1="15" x2="15" y2="25" stroke="#cb0000" stroke-width="2.5" stroke-linecap="round"
                            stroke-miterlimit="10"></line>
                    </svg>
                  </span>
                </button>
              </div>
            }
          </div>
        </div>
      }
      <!-- Room Details -->
      @if (cartContainer?.priceDetail?.total || cartContainer?.promotionData?.couponCard?.zac) {
        <div
          class="pty-rvw"
          id="price-breakup-popover">
          <div class="rvw-detail">
            @if (cartContainer?.newCartDescription?.presentationData?.roomInfo) {
              <div class="rvw-sec">
                {{ cartContainer?.newCartDescription?.presentationData?.roomInfo }}
              </div>
            }
            @if (cartContainer?.newCartDescription?.presentationData?.hourInfo) {
              <div class="rvw-sec">
                {{ cartContainer?.newCartDescription?.presentationData?.hourInfo }}
              </div>
            }
            @if (cartContainer?.newCartDescription?.presentationData?.nightInfo) {
              <div class="rvw-sec">
                {{ cartContainer?.newCartDescription?.presentationData?.nightInfo }}
              </div>
            }
            @if (cartContainer?.newCartDescription?.presentationData?.foodInfo) {
              <div class="rvw-sec">
                {{ cartContainer?.newCartDescription?.presentationData?.foodInfo }}
              </div>
            }
          </div>
          <div class="rvw-prc-wrap">
            <div>
              <div class="rvw-amt">
                <div class="amt">
                  <span>₹</span> <span>{{ cartContainer?.priceDetail?.total }}</span>
                </div>
                <div>
                  <app-b2b-popover-v1
                    [width]="isMobile ? '150px': '240px'"
                    [padding]="'0px'"
                    [left]="'auto'"
                    [right]="'0px'"
                    [allowContentDrop]="true">
                    <div header class="info-icon">
                    <span class="info-img-wrap">
                    <img [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/info_icon.svg?format=png'"
                         alt="info"
                         width="100"
                         height="100" loading="lazy">
                    </span>
                    </div>
                    <div body class="bodySec">
                      <ng-container *ngTemplateOutlet="productPriceBreakup"></ng-container>
                    </div>
                  </app-b2b-popover-v1>
                </div>
              </div>
              <div class="tax">including taxes & fees</div>
            </div>
            @if (cartContainer?.promotionData?.downloadAppCard?.showDownloadAppCard) {
              <div
                class="dld-promo-card">
                <div class="info-dld-card">
                  <div class="title">
                    <a [href]="url"
                       target="_blank"
                       class="a-link header-icon"
                       (click)="analyticsEventService?.fireAnalyticsEvent.emit({ eventName: 'download_app', data: {}})">
                          <span class="title">
                            {{ cartContainer?.promotionData?.downloadAppCard?.title }}
                          </span>
                    </a>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      }
      <!-- Subscription Price Details -->
      @if (cartContainer?.subscriptionPriceDetail?.total) {
        <div class="pty-rvw">
          <div class="rvw-detail">
            @if (cartContainer?.newCartDescription?.presentationData?.subscriptionInfo) {
              <div class="rvw-sec">
                {{ cartContainer?.newCartDescription?.presentationData?.subscriptionInfo }}
              </div>
            }
          </div>
          <div class="rvw-prc-wrap">
            <div class="rvw-amt" id="membership-breakup-popover">
              <div class="amt">₹{{ cartContainer?.subscriptionPriceDetail?.total }}</div>
              <div>
                <app-b2b-popover-v1
                  [width]="isMobile ? '150px': '240px'"
                  [padding]="'0px'"
                  [left]="'auto'"
                  [right]="'0px'"
                  [allowContentDrop]="true">
                  <div header class="info-icon">
                    <span class="info-img-wrap">
                    <img [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/info_icon.svg?format=png'"
                         alt="info"
                         width="100"
                         height="100" loading="lazy">
                    </span>
                  </div>
                  <div body class="bodySec">
                    <ng-container *ngTemplateOutlet="membershipPriceBreakup"></ng-container>
                  </div>
                </app-b2b-popover-v1>
              </div>
            </div>
          </div>
        </div>
      }
      <!-- Coupon Code -->
      @if (cartContainer?.promotionData?.couponCard) {
        <div class="cop-code">
          <div class="input-wrap">
            <div class="cop-wrap">
              <input name="couponCode" [(ngModel)]="coupon" class="input-box"
                     placeholder="Enter COUPON CODE"/>
              <div class="apy-btn">
                <div class="btn" (click)="applyCoupon(cartContainer?.promotionData?.couponCard)">Apply</div>
              </div>
            </div>
            <div (click)="showCouponList(cartContainer?.promotionData?.couponCard)" class="list-btn">View All
              Coupons
            </div>
          </div>
          @if (cartContainer?.promotionData?.couponCard?.title) {
            <div [ngClass]="{
                'cp-applied': cartContainer?.promotionData?.couponCard?.isApplied,
                'cp-error': !cartContainer?.promotionData?.couponCard?.isApplied
                }">
              {{ cartContainer?.promotionData?.couponCard?.title }}
            </div>
          }

          <!--<div class="cpnDisBox">
            @if (cartContainer?.newCartDescription?.premiumMemberCouponDiscountText) {
              <div class="pmDisc">
                {{ cartContainer?.newCartDescription?.premiumMemberCouponDiscountText }}
              </div>
            }

            @if (cartContainer?.newCartDescription?.trueBelieverMemberCouponDiscountText) {
              <div class="tbDisc">
                {{ cartContainer?.newCartDescription?.trueBelieverMemberCouponDiscountText }}
              </div>
            }
          </div>-->
        </div>
      }
      <!-- Redeem Credit Point Card -->
      @if (cartContainer?.promotionData?.redeemCreditPointCard?.isCreditPointApplicable) {
        <div
          class="credit-point">
          <div class="credit-point-box">
            <div class="form-group">
              <input type="checkbox" id="redeemCreditPoint" name="redeemCreditPoint"
                     [(ngModel)]="enableRedeemCreditPoints"
                     (change)="toggleCreditPoint()">
              <label for="redeemCreditPoint"></label>
            </div>
            <!--<input type="checkbox" name="redeemCreditPoint" [(ngModel)]="enableRedeemCreditPoints"
            (change)="toggleCreditPoint()"/>-->
          </div>
          <div class="applied"
               [ngClass]="{ 'cp-applied': cartContainer?.promotionData?.redeemCreditPointCard?.isApplied }">
            {{ cartContainer?.promotionData?.redeemCreditPointCard?.title }}
          </div>
        </div>
      }
      <!-- Sold Out Card -->
      @if (cartContainer?.errorHandler?.soldOutRoomCard?.title) {
        <div class="sold-out-wrap">
          <div class="desc">{{ cartContainer?.errorHandler?.soldOutRoomCard?.description }}</div>
        </div>
      }
      <!-- Common Error Card -->
      @if (!cartContainer?.errorHandler?.soldOutRoomCard?.title) {
        @if (cartContainer?.errorHandler?.commonErrorCard?.title) {
          <div class="sold-out-wrap">
            <div class="desc">{{ cartContainer?.errorHandler?.commonErrorCard?.title }}</div>
          </div>
        }
      }
      <!-- Please select package card -->
      @if (cartContainer?.errorHandler?.pleaseSelectPackageCard?.title) {
        <div class="select-pkg-card"
             (click)="gotoRooms()">
          <div class="title">
            {{ cartContainer?.errorHandler?.pleaseSelectPackageCard?.title }}
            @if (cartContainer?.errorHandler?.pleaseSelectPackageCard?.priceDetail?.rackRate > 0) {
              <span class="rack-rate"
              >
                        <s>INR {{ cartContainer?.errorHandler?.pleaseSelectPackageCard?.priceDetail?.rackRate }}</s>
                      </span>
            }
          </div>
          <div class="flex-container ion-align-items-center prc-bx">
            @if (cartContainer?.errorHandler?.pleaseSelectPackageCard?.priceDetail?.total > 0) {
              <div class="total"
              >
                INR {{ cartContainer?.errorHandler?.pleaseSelectPackageCard?.priceDetail?.total }}
              </div>
            }
            @if (cartContainer?.errorHandler?.pleaseSelectPackageCard?.priceDetail?.totalDetailPageDiscountPercentage > 0) {
              <div class="dis"
              >
                {{ cartContainer?.errorHandler?.pleaseSelectPackageCard?.priceDetail?.totalDetailPageDiscountPercentage }}
                %
                Off
              </div>
            }
          </div>
          <div class="btn">
            {{ cartContainer?.errorHandler?.pleaseSelectPackageCard?.subTitle }}
          </div>
        </div>
      }
      <!-- Please select room card -->
      @if (cartContainer?.errorHandler?.pleaseSelectRoomCard?.title) {
        <div class="rm-err-crd" (click)="gotoRooms()">
          <div class="title">{{ cartContainer?.errorHandler?.pleaseSelectRoomCard?.title }}</div>
          <div class="desc">{{ cartContainer?.errorHandler?.pleaseSelectRoomCard?.description }}</div>
        </div>
      }
      <!-- Limited Room And Guest Card -->
      @if (cartContainer?.errorHandler?.limitedRoomAndGuestCard?.title) {
        <div class="limited-detail-card">
          <div class="title">{{ cartContainer?.errorHandler?.limitedRoomAndGuestCard?.title }}</div>
          <div class="btn">
            <div (click)="gotoSimilarProperties()" class="desc">
              {{ cartContainer?.errorHandler?.limitedRoomAndGuestCard?.description }}
            </div>
          </div>
        </div>
      }
      @if (!nextAvailableDatesAreNotAvailable) {
        <!-- Available Dates Card -->
        @if (cartContainer?.errorHandler?.nextAvailableDatesCard?.title) {
          <div class="date-alb-card"
               [ngClass]="{ '': modifyError?.type === 'AVAILABLE_DATE_ERROR' }">
            <div class="title">{{ cartContainer?.errorHandler?.nextAvailableDatesCard?.title }}</div>
            @if (availableDatesContainer?.length > 0) {
              @if (availableDatesContainer[0]?.options?.length > 0) {
                <app-b2b-drag-scroll [config]="swiperConfig">
                  @for (option of availableDatesContainer[0]?.options; track option) {
                    <app-b2b-drag-scroll-item [config]="swiperConfig">
                      <div class="hour-options title-option" (click)="onNextAvailableDate(option)"
                           [ngClass]="{
                         'selected': option?.date === selectedAvailableDate?.date,
                         'invalid-nad': (!option?.availableRooms || option?.availableRooms === 0)
                        }">
                        <div class="hr-det">
                          <div class="value">
                            <span>Starting at</span>
                            <p>₹ {{ option?.value }}</p>
                          </div>
                          <div class="title">{{ option?.title }}</div>
                        </div>
                        <div class="select">
                          <div class="sel-btn"
                               [ngClass]="{ 'selected': option?.date === selectedAvailableDate?.date }">
                            @if (option?.date === selectedAvailableDate?.date) {
                              <span>
                                        <svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 40 40"
                                             id="tick"
                                             width="15" height="15" fill="#ffffff">
                                          <path
                                            d="M15.48 28.62a1 1 0 0 1-.71-.29l-7.54-7.54a1 1 0 0 1 0-1.41 1 1 0 0 1 1.42 0l6.83 6.83L32.12 9.57a1 1 0 0 1 1.41 0 1 1 0 0 1 0 1.42L16.18 28.33a1 1 0 0 1-.7.29Z"></path></svg>
                                        </span>
                            }
                            @if (option?.availableRooms > 0) {
                              {{ (option?.date === selectedAvailableDate?.date) ? 'SELECTED' : 'SELECT' }}
                            }
                            @if (!option?.availableRooms || option?.availableRooms === 0) {
                              Sold Out
                            }
                          </div>
                        </div>
                      </div>
                    </app-b2b-drag-scroll-item>
                  }
                </app-b2b-drag-scroll>
              }
            }
            @if (modifyError?.type === 'AVAILABLE_DATE_ERROR') {
              <div class="error-msg">{{ modifyError?.message }}</div>
            }
          </div>
        }
        <!-- Available CheckIn Time Card -->
        @if (cartContainer?.errorHandler?.nextAvailableCheckInTimeCard?.title) {
          <div class="tm-lst"
               [ngClass]="{ '': modifyError?.type === 'AVAILABLE_CHECK_IN_TIME_ERROR' }">
            <div class="tm-nme">{{ cartContainer?.errorHandler?.nextAvailableCheckInTimeCard?.title }}</div>
            @if (cartContainer?.errorHandler?.nextAvailableCheckInTimeCard?.description) {
              <div class="tm-desc"
              >
                {{ cartContainer?.errorHandler?.nextAvailableCheckInTimeCard?.description }}
              </div>
            }
            <div class="tm-wrap">
              <div class="tm-crd">
                @for (option of cartContainer?.errorHandler?.nextAvailableCheckInTimeCard?.options; track option) {
                  <div
                    class="tm-chk"
                    (click)="onNextAvailableCheckInTime(option)"
                    [ngClass]="{ 'active': option?.value === selectedAvailableCheckinTime?.value }">
                    {{ option?.title }}
                  </div>
                }
              </div>
              @if (modifyError?.type === 'AVAILABLE_CHECK_IN_TIME_ERROR') {
                <div class="error-msg">{{ modifyError?.message }}</div>
              }
            </div>
          </div>
        }
        <!-- Available Hour Card -->
        @if (cartContainer?.errorHandler?.nextAvailableHourCard?.title) {
          <div class="tm-lst"
               [ngClass]="{ '': modifyError?.type === 'AVAILABLE_HOUR_ERROR' }">
            <div class="tm-nme">{{ cartContainer?.errorHandler?.nextAvailableHourCard?.title }}</div>
            @if (cartContainer?.errorHandler?.nextAvailableHourCard?.description) {
              <div class="tm-desc">
                {{ cartContainer?.errorHandler?.nextAvailableHourCard?.description }}
              </div>
            }
            <div class="tm-wrap">
              @let hourResponse = ((cartContainer?.errorHandler?.nextAvailableHourCard?.options | availableHours : cartContainer?.errorHandler?.nextAvailableCheckInTimeCard : cartContainer?.errorHandler?.nextAvailableHourCard : selectedAvailableCheckinTime)|async);
              <div class="tm-crd">
                @for (option of hourResponse?.options; track option) {
                  <div
                    class="tm-chk"
                    (click)="onNextAvailableHour(option)"
                    [ngClass]="{
                    'active': option?.value === selectedAvailableHour?.value,
                    'disabled': option?.disabled
                    }">
                    {{ option?.title }}
                  </div>
                }
              </div>
              @if (modifyError?.type === 'AVAILABLE_HOUR_ERROR') {
                <div class="error-msg">{{ modifyError?.message }}</div>
              }
              @if (hourResponse?.errorObj?.isError) {
                <div class="error-msg">{{ hourResponse?.errorObj?.message }}</div>
              }
            </div>
          </div>
        }
        <!-- Modify search -->
        @if (cartContainer?.errorHandler?.nextAvailableDatesCard?.title || cartContainer?.errorHandler?.nextAvailableCheckInTimeCard?.title || cartContainer?.errorHandler?.nextAvailableHourCard?.title) {
          <div class="btn-wrap">
            <button class="bkn-now" (click)="modifySearch()" tapEffect>MODIFY SEARCH</button>
          </div>
        }
        <!-- Similar product Card -->
        @if (cartContainer?.errorHandler?.similarProductsCard?.title) {
          <div class="similar-card">
            <div class="title">{{ cartContainer?.errorHandler?.similarProductsCard?.title }}
              <span (click)="gotoSimilarProperties()" class="desc">
                          {{ cartContainer?.errorHandler?.similarProductsCard?.description }}
                        </span>
            </div>
          </div>
        }
      }
      @if (nextAvailableDatesAreNotAvailable) {
        <div class="nxt-avl-dte">
          <!-- <div class="title">Please select alternate properties.</div>-->
          <div class="btn">
            <div (click)="gotoSimilarProperties()" class="desc" tapEffect>
              Check Similar Properties
            </div>
          </div>
        </div>
      }
      @if (cartContainer?.grandTotalPriceDetail?.total || cartContainer?.promotionData?.couponCard?.zac) {
        <div class="btn-wrap"
        >
          <button class="bkn-now" (click)="continueBooking()" tapEffect>BOOK NOW
            for <span>₹ {{ cartContainer?.grandTotalPriceDetail?.total }}</span>
          </button>
        </div>
      }
    </div>
  </div>
  <ng-template #productPriceBreakup>
    <div class="card-details">
      @if (cartContainer?.newCartDescription?.presentationData?.roomInfo) {
        <div class="card-grid">
          <div class="title">
            <!--          {{ cartContainer?.newCartDescription?.presentationData?.roomInfo }}-->
            @if (cartContainer?.newCartDescription?.presentationData?.roomInfo) {
              <div class="rvw-sec">
                {{ cartContainer?.newCartDescription?.presentationData?.roomInfo }}
              </div>
            }
            @if (cartContainer?.newCartDescription?.presentationData?.hourInfo) {
              <div class="rvw-sec">
                {{ cartContainer?.newCartDescription?.presentationData?.hourInfo }}
              </div>
            }
            @if (cartContainer?.newCartDescription?.presentationData?.nightInfo) {
              <div class="rvw-sec">
                {{ cartContainer?.newCartDescription?.presentationData?.nightInfo }}
              </div>
            }
            @if (cartContainer?.newCartDescription?.presentationData?.foodInfo) {
              <div class="rvw-sec">
                {{ cartContainer?.newCartDescription?.presentationData?.foodInfo }}
              </div>
            }
          </div>
          <div class="desc">₹ {{ cartContainer?.priceDetail?.rackRate }}</div>
        </div>
      }
      @if (cartContainer?.priceDetail?.totalPropertyDiscount) {
        <div class="card-grid">
          <div class="title">Property Discount</div>
          <div class="desc">₹ {{ cartContainer?.priceDetail?.totalPropertyDiscount }}</div>
        </div>
      }
      @if (cartContainer?.priceDetail?.offeredPrice) {
        <div class="card-grid">
          <div class="title">Offered Price</div>
          <div class="desc">₹ {{ cartContainer?.priceDetail?.offeredPrice }}</div>
        </div>
      }
      @if (cartContainer?.priceDetail?.totalTax) {
        <div class="card-grid">
          <div class="title">Total Tax and fees</div>
          <div class="desc"> ₹{{ cartContainer?.priceDetail?.totalTax }}</div>
        </div>
      }
      @if (cartContainer?.priceDetail?.totalB2bSpecialDiscount) {
        <div class="card-grid">
          <div class="title">Bag2Bag Special Discount</div>
          <div class="desc">₹ {{ cartContainer?.priceDetail?.totalB2bSpecialDiscount }}</div>
        </div>
      }
      @if (cartContainer?.priceDetail?.membershipDiscount) {
        <div class="card-grid">
          <div class="title">Membership Discount</div>
          <div class="desc">₹ {{ cartContainer?.priceDetail?.membershipDiscount }}</div>
        </div>
      }
      @if (cartContainer?.priceDetail?.couponDiscount) {
        <div class="card-grid">
          <div class="title">Coupon Discount</div>
          <div class="desc">₹ {{ cartContainer?.priceDetail?.couponDiscount }}</div>
        </div>
      }
      @if (cartContainer?.priceDetail?.referralDiscount) {
        <div class="card-grid">
          <div class="title">Referral Discount</div>
          <div class="desc">₹ {{ cartContainer?.priceDetail?.referralDiscount }}</div>
        </div>
      }
      @if (cartContainer?.priceDetail?.creditPointDiscount) {
        <div class="card-grid">
          <div class="title">Credit Point Discount</div>
          <div class="desc">₹ {{ cartContainer?.priceDetail?.creditPointDiscount }}</div>
        </div>
      }
      @if (cartContainer?.priceDetail?.total || cartContainer?.promotionData?.couponCard?.zac) {
        <div
          class="card-grid">
          <div class="title">Total</div>
          <div class="desc">₹ {{ cartContainer?.priceDetail?.total }}</div>
        </div>
      }
    </div>
  </ng-template>
  <ng-template #membershipPriceBreakup>
    <div class="mem-pri-bk-up">
      @if (cartContainer?.subscriptionPriceDetail?.rackRate) {
        <div class="spl-dis">
          <div class="rvw-detail">
            <div class="rvw-sec">{{ cartContainer?.newCartDescription?.presentationData?.subscriptionInfo }}</div>
          </div>
          <div class="rvw-prc-wrap">
            <div class="rvw-amt">
              <div class="amt">₹ {{ cartContainer?.subscriptionPriceDetail?.rackRate }}</div>
            </div>
          </div>
        </div>
      }
      @if (cartContainer?.subscriptionPriceDetail?.totalB2bSpecialDiscount > 0) {
        <div class="spl-dis">
          <div class="rvw-detail">
            <div class="rvw-sec">Existing member discount</div>
          </div>
          <div class="rvw-prc-wrap">
            <div class="rvw-amt">
              <div class="amt">₹ {{ cartContainer?.subscriptionPriceDetail?.totalB2bSpecialDiscount }}</div>
            </div>
          </div>
        </div>
      }
      @if (cartContainer?.subscriptionPriceDetail?.total) {
        <div class="spl-dis">
          <div class="rvw-detail">
            <div class="rvw-sec">Total</div>
          </div>
          <div class="rvw-prc-wrap">
            <div class="rvw-amt">
              <div class="amt">₹ {{ cartContainer?.subscriptionPriceDetail?.total }}</div>
            </div>
          </div>
        </div>
      }
    </div>
  </ng-template>
}

@if (!isServer) {
  <ion-modal #couponModal class="coupon-modal" [initialBreakpoint]="1" [breakpoints]="[0, 1]">
    <ng-template>
      <div class="close-icon" (click)="dismissCouponModal()">
        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20"
             viewBox="0 0 24 24">
          <path fill="#1B569C"
                d="M 4.7070312 3.2929688 L 3.2929688 4.7070312 L 10.585938 12 L 3.2929688 19.292969 L 4.7070312 20.707031 L 12 13.414062 L 19.292969 20.707031 L 20.707031 19.292969 L 13.414062 12 L 20.707031 4.7070312 L 19.292969 3.2929688 L 12 10.585938 L 4.7070312 3.2929688 z"></path>
        </svg>
      </div>
      <div class="header">
        <div class="flex-container ion-justify-content-between ion-align-items-center">
          <!--<div class="title">Coupons</div>-->
          <div class="lft-header">
            <div class="title">Exclusive Offers</div>
            <!--<div class="sub-title">Download App from</div>-->
          </div>
          <div class="dnd-sec">
            <div class="flex-wrap">
              <div class="app-img-flex">
                <div class="gl-img">
                  <a href="https://play.google.com/store/apps/details?id=com.ionicframework.projectx956620"
                     target="_blank">
                    <img
                      [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/Google-playstore-icon-01.png'"
                      alt="Google-playstore" width="100" height="100" loading="lazy"/>
                  </a>
                </div>
                <div class="gl-img">
                  <a href="https://apps.apple.com/us/app/bag2bag-rooms/id1563969368" target="_blank">
                    <img
                      [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/icons/Apple-store-01.png'"
                      alt="Apple-store" width="100" height="100" loading="lazy"/>
                  </a>
                </div>
              </div>
              <div class="scan-sec">
                <div class="qr-sec">
                  <img
                    [ngSrc]="environment?.imgHost + '/new-assets/india/new-app/bar-codes/bag2bag-app-new-qr-code.png'"
                    width="100" height="100" alt="bag2bag-app-qr-code" loading="lazy">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ion-content>
        <div class="coupon-lst-wrap">
          @if (couponContainer?.containers?.length > 0) {
            <div class="coupon-list">
              @for (container of couponContainer?.containers; track container) {
                <div class="cpn-details" [ngClass]="{
                'expired' : !container?.isActive,
                'mobile-app': container?.isMobileApp
                }">
                  <div class="app-card">
                    <div class="coupon-name">
                      <div class="cpn-title">{{ container?.title }}</div>
                      <div class="cpn-desc"
                           [innerHTML]="container?.description | safe: 'html'">
                      </div>
                      <div class="note-title">Mobile App Only Coupon</div>
                      @if (container?.textList) {
                        <div>
                          @for (text of container?.textList; track text) {
                            <div>{{ text }}</div>
                          }
                        </div>
                      }
                    </div>
                    <div class="coupon-btn">
                      <div class="apply-btn">
                        <button class="btn" (click)="applyCouponInModal(container)">Apply</button>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          } @else {
            No coupons are available.
          }
        </div>
      </ion-content>
    </ng-template>
  </ion-modal>
  <ion-modal #bookingInfoModal class="booking-info-modal" [initialBreakpoint]="0.50" [breakpoints]="[1, 0.5, 0.75]">
    <ng-template>
      <div class="header">
        <div class="flex-container ion-justify-content-between ion-align-items-center gap-10">
          <div class="title">Please Verify Check-In details</div>
          <div class="close-icon" (click)="dismissBookingInfoModal()">
            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20"
                 viewBox="0 0 24 24">
              <path fill="#FF8A00"
                    d="M 4.7070312 3.2929688 L 3.2929688 4.7070312 L 10.585938 12 L 3.2929688 19.292969 L 4.7070312 20.707031 L 12 13.414062 L 19.292969 20.707031 L 20.707031 19.292969 L 13.414062 12 L 20.707031 4.7070312 L 19.292969 3.2929688 L 12 10.585938 L 4.7070312 3.2929688 z"></path>
            </svg>
          </div>
        </div>
      </div>
      <ion-content>
        <div class="info-detail">
          @if (compData?.containers?.length > 0) {
            <div class="info-box">
              @for (container of compData?.containers; track container) {
                @if (container?.newCartDescription?.checkin) {
                  <div class="info-wrap">
                    <div class="title">Check In</div>
                    <div class="desc">{{ container?.newCartDescription?.checkin }}</div>
                  </div>
                }
                @if (container?.newCartDescription?.checkout) {
                  <div class="info-wrap">
                    <div class="title">Check Out</div>
                    <div class="desc">{{ container?.newCartDescription?.checkout }}</div>
                  </div>
                }
                @if (container?.newCartDescription?.totalHours) {
                  <div class="info-wrap">
                    <div class="title">Total Hour</div>
                    <div class="desc">{{ container?.newCartDescription?.totalHours + ' Hour' }}</div>
                  </div>
                }
              }
            </div>
          } @else {
            <div class="err-msg flex-container ion-align-items-center ion-justify-content-center">
              Check-In Details are Not Available.
            </div>
          }
        </div>
        <div class="footer">
          @if (compData?.containers?.length > 0; ) {
            <div
              class="foot-btn flex-container ion-justify-content-end ion-align-items-center">
              <div (click)="dismissBookingInfoModal(); modify();" class="mod-btn" tapEffect>Modify</div>
              <div (click)="dismissBookingInfoModal(); continueToBooking();" class="sus-btn" tapEffect>Looks Good</div>
            </div>
          }
        </div>
      </ion-content>
    </ng-template>
  </ion-modal>
}
